<template>
    <div>
        
    </div>
</template>
    
<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({

	}),
    computed: {
        ...mapGetters(['currentSituationID','currentSituation']),
    },
    watch: {
        currentSituationID: function () {
            if(this.currentSituationID){
                let currentSituationName = this.currentSituation.getName().trim();
                let alpha = 0;
                let beta = Math.PI/2;
                switch (currentSituationName) {
                    case "Start": alpha = Math.PI/1.65; beta = Math.PI/1.8; break;
                    case "Reception": alpha = Math.PI/0.94; beta = Math.PI/2; break;
                    case "Meeting Room Hamburg": alpha = Math.PI/0.81; beta = Math.PI/2.1; break;
                    case "Meeting Room Freudenberg": alpha = 5.2; beta = Math.PI/2.1; break;
                    case "Showroom Curing Presses": alpha = 0; beta = Math.PI/2.25; break;
                    case "Showroom Mixing Group": alpha = -.2; beta = Math.PI/2; break;
                    case "Tire Building - Top View": alpha = 0; beta = 0; break;

                    // case "Wartebereich": alpha = 0.5; beta = Math.PI/2.2; break;
                    // case "Lounge": alpha = 0; beta = Math.PI/2; break;
                    // case "Skylounge 1": alpha = Math.PI/0.95; beta = Math.PI/2; break;
                    // case "Skylounge 2": alpha = 0; beta = Math.PI/2; break;
                    // case "Dachterrasse": alpha = 0; beta = Math.PI/2; break;
                    // case "Innenhof": alpha = Math.PI/1.2; beta = Math.PI/1.7; break;
                    // case "Büro 1": alpha = Math.PI/1.8; beta = Math.PI/2; break;
                    // case "Büro 2": alpha = Math.PI/0.75; beta = Math.PI/2; break;
                    // case "Produktion - Überblick - 1. OG": alpha = 0; beta = Math.PI/2.3; break;
                    // case "Produktion - Überblick - 2. OG": alpha =  Math.PI*2-0.4; beta = Math.PI/2.6; break;
                    // case "Produktion - Überblick - EG": alpha =  1.8; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 1": alpha = Math.PI/0.9; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 2": alpha = Math.PI*2-0.8; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 3": alpha = Math.PI*2-0.8; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 4": alpha = 4.7; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 5": alpha = Math.PI*2-0.3; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 6": alpha = 0.8; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 7": alpha = 1; beta = Math.PI/2; break;
                    // case "Produktion - Rundgang 8": alpha = 0; beta = Math.PI/2; break;
                    // case "Lager": alpha = 5.3; beta = Math.PI/2; break;
                    default: 
                        break;
                }

                window.scene.activeCamera.alpha = alpha;
                window.scene.activeCamera.beta = beta;

                if(currentSituationName == "Start"){
                    window.scene.activeCamera.lowerBetaLimit = 1.5;
                    window.scene.activeCamera.upperBetaLimit = 2.1;
                    window.scene.activeCamera.lowerAlphaLimit = 1.5;
                    window.scene.activeCamera.upperAlphaLimit = 2.2;
                }else{
                    window.scene.activeCamera.lowerBetaLimit = 0.01;
                    window.scene.activeCamera.upperBetaLimit = Math.PI;
                    window.scene.activeCamera.lowerAlphaLimit = null;
                    window.scene.activeCamera.upperAlphaLimit = null;
                }
            }
		}
	},

}
</script>

<style>
    
</style>